import { call, delay, put, takeLatest } from "redux-saga/effects";
import CONSTANTS from "./constants";
import BOTTOMSHEETCONSTANTS from "@src/components/BottomSheets/store/constants";
import {
  captureInterestService,
  getCourseFacultyList,
  getCourseOverviewService,
  getDynamicCourseListService,
  getIndividualInstallmentService,
  getNewServiceUpcomingAndLiveCard,
  getOrgDetailsService,
  getPriceActionService,
  getTabListService,
  getUserDetailsActionService,
  postLikeCourseService,
  postTightOnBudgetBottomSheetClose,
  updatePreferredStateService,
} from "./services";

import {
  applyCourseCouponStudent,
  getCourseCouponListStudent,
  getDynamicBundlingPricing,
  removeCourseCouponStudent,
} from "@src/graphApis/index";
import { executeQuery } from "@src/graphApis/graph";
import { store } from "@root/store";
import { updateLikeCourseCountAction } from "./actions";
import toast from "react-hot-toast";
import { openPullToRefreshAction } from "../../../PullToRefresh/store";
import { setUserDetailsInfoAction } from "@src/layout/store/actions";

import { newWebEngage } from "@src/utils/webEngageEvent";
import { initCosmos, updateUserCosmos } from "@src/cosmosTracking";
import {
  getAddressListAction,
  savePincodeErrorMsg,
} from "../../../PhysicalAddress/store/actions";
import { getCourseCouponStudentOverviewService } from "../../../UIElements/TabBar/store/services";
import { checkMmServiceEnabledOnCourses } from "@src/utils/liveService/util";

function* getTabListsSaga(data) {
  // console.log("in tablist saga------------------------------");
  yield put({
    type: CONSTANTS.GET_TAB_LIST_LOADER,
    tabListLoading: true,
  });
  try {
    const response = yield call(getTabListService, {
      data,
    });
    // console.log(response.data.data, "------------------------------------");
    yield put({
      type: CONSTANTS.GET_TAB_LIST_LOADER,
      tabListLoading: false,
    });
    yield put({
      type: CONSTANTS.GET_TAB_LIST_DATA_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    // console.log(error, "===========");
    yield put({
      type: CONSTANTS.GET_TAB_LIST_DATA_FAILURE,
      tabListLoading: false,
      tabListFailure: true,
    });
  }
}

function* getPriceActionSaga(data) {
  // console.log("in price saga------------------------------");

  yield put({
    type: CONSTANTS.GET_COURSE_PRICE_LOADER,
    priceDetailsLoading: true,
  });
  try {
    const response = yield call(getPriceActionService, {});
    // console.log(response.data.data, "------------------------------------");
    yield put({
      type: CONSTANTS.GET_COURSE_PRICE_LOADER,
      priceDetailsLoading: false,
    });
    yield put({
      type: CONSTANTS.GET_COURSE_PRICE_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    // console.log(error, "===========");
    yield put({
      type: CONSTANTS.GET_COURSE_PRICE_FAILURE,
      priceDetailsLoading: false,
      priceDetailsFailure: true,
    });
  }
}

function* getCourseOverviewSaga(data) {
  // console.log("in course overview saga------------------------------", data);
  // console.log(data);
  // alert("getCourseContentSaga");
  // alert(`saga payload: ${JSON.stringify(data)}`);
  // console.log(getCourseOverviewService);
  if (data?.payload?.isLoading) {
    yield put({
      type: CONSTANTS.GET_OVERVIEW_DATA_LOADER,
      overViewDetailsLoading: true,
    });
  }
  if (data?.payload?.showForcefulShimmer) {
    yield put({
      type: CONSTANTS.SET_FORCEFUL_SHIMMER,
      payload: true,
    });
  }
  try {
    if (data?.payload?.isDelay) {
      yield delay(1500);
    }
    // alert("getCourseContentSaga--call--getCourseOverviewService");
    const response = yield call(getCourseOverviewService, {
      courseId: data.payload?.courseId,
    });
    let courseData = response?.data?.data || {};
    
    // alert("getCourseContentSaga--put--GET_OVERVIEW_DATA_LOADER");
    yield put({
      type: CONSTANTS.GET_OVERVIEW_DATA_LOADER,
      overViewDetailsLoading: false,
    });

    yield put({
      type: CONSTANTS.SET_FORCEFUL_SHIMMER,
      payload: false,
    });

    // alert("getCourseContentSaga--put--GET_OVERVIEW_DATA_SUCCESS");
    yield put({
      type: CONSTANTS.GET_OVERVIEW_DATA_SUCCESS,
      payload: courseData,
    });

    const addOnOptionIdValue = response?.data?.data?.course?.metaData?.addOnData?.addOnOptionId ?? 0;
    const prePurchaseAddOnAmountValue = response?.data?.data?.course?.metaData?.addOnData?.prePurchaseAddOnAmount ?? 0;
    const prePurchasePopUpEnabledValue =
      (response?.data?.data?.course?.metaData?.addOnData?.prePurchaseMoneyBackPopUpEnabled ??
        response?.data?.data?.course?.metaData?.addOnData?.prePurchaseGuaranteedSelectionProgramPopUpEnabled) ?? 0;

    const isPhysicalDeliveryEnabled =
      response?.data?.data?.course?.metaData?.isPhysicalDeliveryEnabled;
      yield put({
        type: CONSTANTS.MONEY_BACK_GUARANTEE,
        payload:{
          addOnOptionId: addOnOptionIdValue,
          prePurchaseAddOnAmount:prePurchaseAddOnAmountValue,
          prePurchasePopUpEnabled:prePurchasePopUpEnabledValue,
          isRemoveButtonEnable: true,
        }
      })

    const isFreeCourse = response?.data?.data?.course?.metaData?.isFreeCourse || 0;
    if(!isFreeCourse){
      yield put({
        type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS,
        payload: {
          optedAddOn:addOnOptionIdValue,
          courseIds: [`${data.payload?.courseId}`],
          isBundlingCourse: false,
          graphCourseDataLoading:
            data.payload.showPaymentLoader != undefined
              ? data.payload.showPaymentLoader
              : true,
          isPhysicalDeliveryEnabled,
          autopayConfigId: data?.payload?.autopayConfigId
        },
      });
    }
    // console.log(response.data.data, "getCourseOverviewService");
    const isMoneyBack = store?.getState()?.overviewReducer?.moneyBackGuarantee?.addOnOptionId || 0;
    const isRemoveButtonEnable = store?.getState()?.overviewReducer?.moneyBackGuarantee?.isRemoveButtonEnable;
    if (
      response?.data?.data?.course?.installments?.installmentData ||
      response?.data?.data?.course?.installments?.installmentPaymentData
    ) {
      yield put({
        type: CONSTANTS.GET_INDIVIDUAL_INSTALLMENT,
        payload: {
          courseId: data.payload?.courseId,
          installmentId:
            response.data.data?.course?.installments?.installmentId ||
            response?.data?.data?.course?.installments?.activeInstallmentId,
            ...(isMoneyBack && isRemoveButtonEnable) ? {optedAddOn: isMoneyBack} : null,
        },
      });
    }
    
    const mmServiceEnabledOnCourses = checkMmServiceEnabledOnCourses()
    if (mmServiceEnabledOnCourses){
      const upcomingAndLiveClassResponse = yield call(getNewServiceUpcomingAndLiveCard, {
        courseId: data.payload?.courseId
      })
      if (upcomingAndLiveClassResponse?.data) {
        if (!courseData.course) {
          courseData.course = {};
        }
        
        yield put({
          type: CONSTANTS.SET_UPCOMING_LIVE_CLASS,
          payload: upcomingAndLiveClassResponse?.data?.data
        })
      }
    }
    // const tabListAction = yield call(getTabListAction, { courseId: data.payload?.courseId, skipLoader: true });
    // yield put({ ...tabListAction });

    // IF DATA IS GETTING REFETCHED FROM PULL TO REFRESH ACTION YOU NEED TO CLOSE THE PULL TO REFRESH LOADER
    if (data?.payload?.isPullToRefreshAction) {
      const pullToRefreshAction = yield call(openPullToRefreshAction);
      yield put({ ...pullToRefreshAction });
    }
    initCosmos();
  } catch (error) {
    initCosmos();
    // console.log(error, "===========");
    // alert(JSON.stringify(error?.response))
    // Router.push("/404");
    // alert("getCourseContentSaga--catch");
    // alert(`error: ${JSON.stringify(error)}`)
    // alert(`error.response: ${JSON.stringify(error?.response)}`)
    // alert(`error.response.data: ${JSON.stringify(error?.response?.data)}`)
    yield put({
      type: CONSTANTS.GET_OVERVIEW_DATA_FAILURE,
      overViewDetailsLoading: false,
      overViewDetailsFailure: true,
    });
  }
}
function* postLikeCourseSaga(data) {
  // console.log("in post like course saga------------------------------");
  // console.log(data);
  try {
    const response = yield call(postLikeCourseService, {
      ...data.payload,
    });
    // console.log(response.data.data, "------------------------------------");
    // yield put({
    //   type: CONSTANTS.POST_LIKE_COURSE_SUCCESS,
    //   payload: response.data.data,
    // });
    // console.log("A________", response?.data?.data?.status)
    // yield call(updateLikeCourseCountAction, response?.data?.data?.status)
    yield delay(100);
    const updateLikeAction = yield call(
      updateLikeCourseCountAction,
      response?.data?.data?.status
    );
    yield put({ ...updateLikeAction });
  } catch (error) {
    // console.log(error, "===========");
    yield put({
      type: CONSTANTS.POST_LIKE_COURSE_FAILURE,
      overViewDetailsLoading: false,
      overViewDetailsFailure: true,
    });
  }
}
function* getUserDetailsActionSaga(data) {
  // console.log("in get user details saga------------------------------");
  // console.log(data);
  try {
    const response = yield call(getUserDetailsActionService, {
      ...data.payload,
    });
    // console.log(
    //   response?.data?.data?.responseData?.user,
    //   "get user details------------------------------------"
    // );
    yield put({
      type: CONSTANTS.GET_USER_DETAILS_SUCCESS,
      payload: response.data.data,
    });

    const userDetailsInfo = response?.data?.responseData || response?.data?.data?.responseData || {};
    const setUserDetailsInfo = yield call(setUserDetailsInfoAction, userDetailsInfo);
    yield put({ ...setUserDetailsInfo });

    if (response.data.data) {
      // initWebEngage(response?.data?.data?.responseData?.user);
      updateUserCosmos();
    }
  } catch (error) {
    // console.log(error, "===========");
    yield put({
      type: CONSTANTS.GET_USER_DETAILS_ERROR,
      overViewDetailsLoading: false,
      overViewDetailsFailure: true,
    });
  }
}
function* getOrgDetailsSaga(data) {
  // console.log("in get org details saga------------------------------");
  try {
    const response = yield call(getOrgDetailsService, {
      ...data.payload,
    });
    // console.log(response.data, "------------------------------------");
    yield put({
      type: "SET_ORG_DETAILS_DATA",
      payload: response.data.data,
    });
  } catch (error) {
    // console.log(error, "===========");
    yield put({
      type: CONSTANTS.GET_ORG_DETAILS_FAILURE,
    });
  }
}

function* getGraphCoursePriceDetailsSaga(data) {
  const currentMoneyBackPrice = data?.payload?.optedAddOn;
  const ocvmId =
    store?.getState()?.overviewReducer?.promotedValidity?.id || null;

  yield put({
    type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_LOADER,
    graphCourseDataLoading:
      data.payload.graphCourseDataLoading !== undefined
        ? data.payload.graphCourseDataLoading
        : true,
    graphCourseDataStatus: "",
  });

  function getMoneyBackPrice(data, key) {
    return data?.reduce((acc, val) => {
      if (val["enumKey"] === key) {
        acc = val["value"];
        return acc;
      }
      return acc; // Ensure the updated value is returned.
    }, 0);

  }

  delete data.payload.graphCourseDataLoading;

  let currentCouponCode = data.payload.currentCouponCode;
  let avoidCouponsList = data.payload.avoidCouponsList;

  delete data.payload.avoidCouponsList;

  let priceDetailsPayload = { ...data.payload };
  let deliveryFee = store?.getState()?.physicalShipmentReducer?.deliveryFee;
  let isPhysicalDeliveryEnabled =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
      ?.isPhysicalDeliveryEnabled;
  priceDetailsPayload["deliveryFee"] =
    isPhysicalDeliveryEnabled === 2
      ? deliveryFee === 0
        ? -1
        : deliveryFee
      : 0;
  const isMoneyBack = store?.getState()?.overviewReducer?.moneyBackGuarantee?.addOnOptionId || 0;
  const isRemoveButtonEnable = store?.getState()?.overviewReducer?.moneyBackGuarantee?.isRemoveButtonEnable;

  // console.log("+++++priceDetailsPayload", priceDetailsPayload);
  let bundleid =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
      ?.bundleData?.bundleId;
  let purchaseViaWhatsappV2 =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2;

  const response = yield call(getCourseCouponStudentOverviewService, {
    ...priceDetailsPayload,
    ocvmId: data?.payload?.variables?.ocvmId || ocvmId,
    bundlingId: bundleid,
    purchaseViaWhatsappV2,
    optedAddOn: currentMoneyBackPrice === 'remove' ? 0 : isRemoveButtonEnable ? isMoneyBack : 0 ,
    autopayConfigId: data?.payload?.autopayConfigId || null,
  });

  let courseId =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.id;

  if (response.status >= 200 && response.status <= 300) {
    if (!response.hasErrors) {
      const priceKey = isMoneyBack === 1 ? 'Money Back Guarantee' : isMoneyBack === 4 ? 'Guaranteed Selection Program' : 'Unknown';
      const moneyBackPrice = getMoneyBackPrice(response?.data?.data?.coupons?.[0]?.priceDetails, priceKey) || 0;
      yield put({
        type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_SUCCESS,
        graphCourseDataLoading: false,
        graphCourseDataError: false,
        graphCourseData: response.data.data,
        graphCourseDataStatus: "SUCCESS",
        currentCouponCode: currentCouponCode ? currentCouponCode : {},
      });
      yield put({
        type:CONSTANTS.MONEY_BACK_GUARANTEE_PRICE,
        payload:moneyBackPrice
      })
      const isGooglePlayEnabled = store?.getState()?.overviewReducer?.overViewDetails?.course?.isGooglePlayEnabled;
      const is_apk = localStorage.getItem("isAPKFlag");
      if (!avoidCouponsList && (isGooglePlayEnabled !== 1 || is_apk === "1"))
        yield put({
          type: CONSTANTS.GET_GRAPH_COUPONS_LIST,
          payload: {
            variables: {
              courseId: `${courseId}`,
              limit: 20,
              offset: 0,
              isPhysicalDeliveryEnabled:
                data?.payload?.isPhysicalDeliveryEnabled,
            },
          },
        });
    } else {
      //status > 200 && <300 but error
      toast.error(response.message);
      yield put({
        type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_FAILURE,
        graphCourseDataLoading: false,
        graphCourseDataError: true,
        // graphCourseData: response.data.data,
        graphCourseDataStatus: "FAILURE",
      });
    }
  } else {
    //Status is undefined
    toast.error(response.message);
    yield put({
      type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_FAILURE,
      graphCourseDataLoading: false,
      graphCourseDataError: true,
      // graphCourseData: response.data.data,
      graphCourseDataStatus: "FAILURE",
    });
    // showErrorToaster &&
  }
}

function* getGraphCouponsListSaga(data) {
  let bundleid =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
      ?.bundleData?.bundleId;
  // console.log("amit", san);
  yield put({
    type: CONSTANTS.GET_GRAPH_COUPONS_LIST_LOADER,
    graphCourseCouponListDataLoading: true,
    graphCourseCouponListDataStatus: "",
  });

  const response = yield call(executeQuery, {
    ...data.payload,
    bundlingId: bundleid,
    query: getCourseCouponListStudent,
    purchaseViaWhatsappV2: store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2,
  });

  let currentCouponsListData =
    store?.getState()?.overviewReducer?.graphCourseCouponListData;

  // console.log("currentCouponsListData", currentCouponsListData);

  //console.log(response, '*****graphResponse');
  //console.log(data.payload.variables.offset == 0 || !data.payload.variables.offset, 'data.payload.code');

  if (response.status >= 200 && response.status <= 300) {
    if (!response.hasErrors) {
      yield put({
        type: CONSTANTS.GET_GRAPH_COUPONS_LIST_SUCCESS,
        graphCourseCouponListDataLoading: false,
        graphCourseCouponListDataError: false,
        graphCourseCouponListData:
          data.payload.variables.offset == 0 || !data.payload.variables.offset
            ? response.data.data
            : {
                ...response.data.data,
                coupons: [
                  ...currentCouponsListData.coupons,
                  ...response.data.data.coupons,
                ],
              },
        graphCourseCouponListDataStatus: "SUCCESS",
        updateGraphCourseCouponOffset:
          data.payload.variables.offset == 0 || !data.payload.variables.offset
            ? false
            : true,
      });
    } else {
      yield put({
        type: CONSTANTS.GET_GRAPH_COUPONS_LIST_FAILURE,
        graphCourseCouponListDataLoading: false,
        graphCourseCouponListDataError: true,
        graphCourseCouponListData: response.data.data,
        graphCourseCouponListDataStatus: "FAILURE",
      });
    }
  } else {
    yield put({
      type: CONSTANTS.GET_GRAPH_COUPONS_LIST_FAILURE,
      graphCourseCouponListDataLoading: false,
      graphCourseCouponListDataError: true,
      // graphCourseCouponListData: response.data.data,
      graphCourseCouponListDataStatus: "FAILURE",
    });
  }
}

function* applyCouponSaga(data) {
  const ocvmId =
    store?.getState()?.overviewReducer?.promotedValidity?.id || null;
  let redemptionId =
    store?.getState()?.overviewReducer?.graphCourseData?.appliedCoupon
      ?.redeemId;
  let bundleid =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData
      ?.bundleData?.bundleId;

  yield put({
    type: CONSTANTS.APPLY_COURSE_COUPON_LOADER,
    graphCourseCouponListDataLoading: true,
    graphCourseCouponListDataStatus: "",
  });

  const response = yield call(executeQuery, {
    variables: {
      ...data.payload.variables,
      ocvmId: data?.payload?.variables?.ocvmId || ocvmId,
      ...(data?.checkForMultipleValidity &&
        redemptionId && { redeemId: redemptionId }),
      bundleId: bundleid?.toString(),
    },
    query: applyCourseCouponStudent,
    purchaseViaWhatsappV2: store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2,
  });
  // console.log("+++response", response);

  let courseId =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.id;

  if (response.status >= 200 && response.status <= 300) {
    if (!response.hasErrors) {
      yield put({
        type: BOTTOMSHEETCONSTANTS.BOTTOMSHEET_APPLY_COUPON,
        payload: false,
      });

      newWebEngage("course_coupon_applied", {
        action: "Coupon Code Applied",
        coupon_code: `${data.payload.variables.code}`,
      });

      yield put({
        type: CONSTANTS.APPLY_COURSE_COUPON_SUCCESS,
        payload: response,
      });

      // yield put({
      //   type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS,
      //   payload: {
      //     courseIds: [`${courseId}`],
      //     isBundlingCourse: false,
      //   },
      // });
    } else {
      //status > 200 && <300 but error

      toast.error(response?.message);

      yield put({
        type: CONSTANTS.APPLY_COURSE_COUPON_FAILURE,
      });
    }
  } else {
    //Status is undefined

    toast.error(response?.message);
    yield put({
      type: CONSTANTS.APPLY_COURSE_COUPON_FAILURE,
    });
    if (redemptionId && data?.checkForMultipleValidity) {
      yield put({
        type: CONSTANTS.SHOW_COUPON_MODAL,
        payload: { isCouponModal: true },
      });
      yield put({
        type: CONSTANTS.REMOVE_COURSE_COUPON,
        payload: {
          variables: { redemptionId, code: data.payload.variables?.code },
          query: removeCourseCouponStudent,
        },
      });
    }
  }
}

function* applyCouponFakeLoadingSaga(data) {
  yield put({
    type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_LOADER,
    graphCourseDataLoading: true,
    graphCourseDataStatus: "",
  });

  yield delay(100);

  yield put({
    type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS_LOADER,
    graphCourseDataLoading: false,
    graphCourseDataStatus: "",
  });
}
function* tightOnBudgetBottomsheetCloseSaga(data) {
  try {
    const response = yield call(postTightOnBudgetBottomSheetClose, {
      ...data.payload,
    });
    // console.log(response.data, "------------------------------------");
  } catch (error) {
    // console.log(error, "===========");
  }
}

function* removeCouponSaga(data) {
  const ocvmId =
    store?.getState()?.overviewReducer?.promotedValidity?.id || null;
  yield put({
    type: CONSTANTS.REMOVE_COURSE_COUPON_LOADER,
    graphCourseCouponListDataLoading: true,
    graphCourseCouponListDataStatus: "",
  });

  const response = yield call(executeQuery, {
    variables: {
      ...data.payload.variables,
      ocvmId: data?.payload?.variables?.ocvmId || ocvmId,
    },
    query: removeCourseCouponStudent,
    purchaseViaWhatsappV2: store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2,
  });

  // console.log("+++response", response);

  let courseId =
    store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.id;

  if (response.status >= 200 && response.status <= 300) {
    // toast.success("Coupon Removed Successfully");

    if (!response.hasErrors) {
      yield put({
        type: BOTTOMSHEETCONSTANTS.BOTTOMSHEET_APPLY_COUPON,
        payload: false,
      });

      yield put({
        type: CONSTANTS.REMOVE_COURSE_COUPON_SUCCESS,
        payload: response,
      });

      newWebEngage("course_coupon_removed", {
        action: "Coupon Code Removed",
        coupon_code: `${data.payload.variables.code}`,
      });

      yield put({
        type: CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS,
        payload: {
          courseIds: [`${courseId}`],
          isBundlingCourse: false,
          autopayConfigId: store?.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig?.id || null,
        },
      });
    } else {
      //status > 200 && <300 but error

      toast.error(response?.message);

      yield put({
        type: CONSTANTS.REMOVE_COURSE_COUPON_FAILURE,
      });
    }
  } else {
    //Status is undefined

    toast.error(response?.message);
    yield put({
      type: CONSTANTS.REMOVE_COURSE_COUPON_FAILURE,
    });
  }
}

function* funnelTracking(data) {
  // console.log(data);
  try {
    // const response = yield call(funnelTrackingService, {
    //   ...data.payload,
    // });
    // console.log("funnelTracking api response", response);
  } catch (error) {
    // console.log("funnelTracking api error", error);
  }
}
function* getIndividualInstallmentSaga(data) {
  yield put({
    type: CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_LOADER,
    payload: true,
  });
  try {
    const response = yield call(getIndividualInstallmentService, {
      ...data.payload,
    });

    // console.log("funnelTracking api response", response);
    yield put({
      type: CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_SUCCESS,
      payload: response?.data?.data?.formData,
    });
  } catch (error) {
    yield put({
      type: CONSTANTS.GET_INDIVIDUAL_INSTALLMENT_FAILURE,
    });
  }
}

function* getCourseFacultyListSaga(data) {
  const payload = data?.payload;
  try {
    const response = yield call(getCourseFacultyList, { courseId: payload });
    yield put({
      type: CONSTANTS.SAVE_COURSE_FACULTY_LIST,
      payload: response?.data?.data,
    });
  } catch (error) {
    yield put({
      type: CONSTANTS.SAVE_COURSE_FACULTY_LIST,
      payload: null,
    });
  }
}

function* getDynamicCourseListSaga(data) {
  const payload = data?.payload;
  try {
    yield put({
      type: CONSTANTS.SET_DYNAMIC_BUNDLING_SELECTED,
      payload: [],
    });
    const response = yield call(getDynamicCourseListService, {
      courseId: payload,
    });
    // debugger;
    yield put({
      type: CONSTANTS.GET_DYNAMIC_COURSE_LIST_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    yield put({
      type: CONSTANTS.GET_DYNAMIC_COURSE_LIST_FAILURE,
      payload: null,
    });
  }
}

function* getDynamicCoursePriceSaga(data) {
  const ocvmId =
    store?.getState()?.overviewReducer?.promotedValidity?.id || null;
  const payload = data?.payload;
  yield put({
    type: "SET_DYNAMIC_BUNDLING_BTN_LOADER",
    payload: true,
  });
  let res = yield call(executeQuery, {
    variables: {
      courseIds: payload?.courseIds,
      courseId: payload?.courseId,
      primaryCourseId: payload?.courseId,
      isBundlingCourse: true,
      ocvmId: data?.payload?.variables?.ocvmId || ocvmId,
    },
    query: getDynamicBundlingPricing,
    purchaseViaWhatsappV2: store?.getState()?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2,
  });
  if (res?.hasErrors) {
    yield put({
      type: CONSTANTS.GET_DYNAMIC_COURSE_PRICE_FAILURE,
    });
    yield put({
      type: "SET_DYNAMIC_BUNDLING_BTN_LOADER",
      payload: false,
    });
  } else {
    // debugger;
    let isPhyicalShipmentCourse =
      res?.data?.data?.priceBottom?.isPhyicalShipmentCourse;
    yield put(
      savePincodeErrorMsg({
        msg: "",
        pincode: "",
        deliveryFee: 0,
        disableBuyNowBtn: false,
      })
    );
    yield put(
      store?.dispatch(
        getAddressListAction({
          isPhysical: isPhyicalShipmentCourse,
        })
      )
    );
    yield put({
      type: CONSTANTS.UPDATE_PHYSICAL_DELIVERY_ENABLED,
      payload: isPhyicalShipmentCourse,
    });
    yield put({
      type: CONSTANTS.GET_DYNAMIC_COURSE_PRICE_SUCCESS,
      payload: res?.data?.data,
    });
    yield put({
      type: "SET_DYNAMIC_BUNDLING_BTN_LOADER",
      payload: false,
    });
  }
}

function* updatePreferredStateSaga({ payload: state }) {
  try {
    const enablePrefilledState =
      store?.getState()?.overviewReducer?.overViewDetails?.course
        ?.enablePrefilledState;
    if (enablePrefilledState) {
      yield call(updatePreferredStateService, { state });
    }
  } catch (error) {}
}

function* captureInterestSaga(payload) {
  try {
    const res = yield call(captureInterestService, payload?.payload);
    yield put({
      type: CONSTANTS.BUY_NOW_SUCCESS_MODAL,
      payload: true,
    });
  } catch (error) {}
}

export default function* actionWatcher() {
  yield takeLatest(CONSTANTS.GET_TAB_LIST_DATA, getTabListsSaga);
  yield takeLatest(CONSTANTS.GET_COURSE_PRICE, getPriceActionSaga);
  yield takeLatest(CONSTANTS.GET_OVERVIEW_DATA, getCourseOverviewSaga);
  yield takeLatest(CONSTANTS.SET_SELECTED_STATE, updatePreferredStateSaga);
  yield takeLatest(CONSTANTS.POST_LIKE_COURSE, postLikeCourseSaga);
  yield takeLatest(CONSTANTS.GET_USER_DETAILS, getUserDetailsActionSaga);
  yield takeLatest(
    CONSTANTS.GET_GRAPH_COURSE_PRICE_DETAILS,
    getGraphCoursePriceDetailsSaga
  );
  yield takeLatest(CONSTANTS.GET_GRAPH_COUPONS_LIST, getGraphCouponsListSaga);
  yield takeLatest(CONSTANTS.APPLY_COURSE_COUPON, applyCouponSaga);
  yield takeLatest(CONSTANTS.REMOVE_COURSE_COUPON, removeCouponSaga);
  yield takeLatest(
    CONSTANTS.APPLY_COUPON_FAKE_LOADING,
    applyCouponFakeLoadingSaga
  );
  yield takeLatest(CONSTANTS.GET_ORG_DETAILS, getOrgDetailsSaga);
  yield takeLatest(
    CONSTANTS.TIGHT_BUDGET_BOTTOMSHEET_CLOSE,
    tightOnBudgetBottomsheetCloseSaga
  );
  yield takeLatest(CONSTANTS.FUNNEL_TRACKING, funnelTracking);
  yield takeLatest(
    CONSTANTS.GET_INDIVIDUAL_INSTALLMENT,
    getIndividualInstallmentSaga
  );
  yield takeLatest(CONSTANTS.GET_COURSE_FACULTY_LIST, getCourseFacultyListSaga);
  yield takeLatest(CONSTANTS.CAPTURE_INTEREST, captureInterestSaga);
  yield takeLatest(CONSTANTS.GET_DYNAMIC_COURSE_LIST, getDynamicCourseListSaga);
  yield takeLatest(
    CONSTANTS.GET_DYNAMIC_COURSE_PRICE,
    getDynamicCoursePriceSaga
  );
}
